@if (collapsed()) {
  <aside class="flex h-full max-h-full flex-col items-center overflow-y-auto px-1.5 py-2">
    <div
      (click)="headerClick.emit()"
      (keydown.enter)="headerClick.emit()"
      [attr.aria-label]="'sidebar.close_aria' | translate"
      class="hover:bg-interactive mb-1 flex size-8 cursor-pointer items-center justify-center rounded-sm transition-colors"
      tabindex="0">
      <i [class]="listIcon" class="text-xl"></i>
    </div>

    <img alt="Galia Logo" class="mb-3 size-8 select-none" src="favicon.svg" />

    <div class="bg-weak mb-3 h-px w-full"></div>

    <ul class="w-full grow space-y-1">
      @for (item of topItems(); track trackSidebarItemByRoute($index, item)) {
        <app-sidebar-item
          [label]="item.labelKey | translate"
          [item]="item.item"
          [collapsed]="true" />
      }
    </ul>

    @if (bottomItems().length > 0) {
      <div class="bg-weak my-2 h-px w-full"></div>
    }

    <ul class="w-full space-y-1">
      @for (item of bottomItems(); track trackSidebarItemByRoute($index, item)) {
        <app-sidebar-item
          [label]="item.labelKey | translate"
          [item]="item.item"
          [collapsed]="true" />
      }
    </ul>

    @if (user()) {
      <div class="border-weak mt-2 flex w-full justify-center border-t pt-2.5 pb-1">
        <div
          class="bg-accent-interactive text-accent-main flex size-7 shrink-0 items-center justify-center rounded-full font-sans text-xs font-semibold">
          {{ initials() }}
        </div>
      </div>
    }
  </aside>
} @else {
  <aside class="flex h-full max-h-full flex-col overflow-y-auto px-3 py-2">
    <div class="border-weak mb-3 flex items-center gap-2.5 border-b px-1 pt-1 pb-3">
      <div
        (click)="headerClick.emit()"
        (keydown.enter)="headerClick.emit()"
        [attr.aria-label]="'sidebar.close_aria' | translate"
        class="flex size-6 cursor-pointer items-center justify-center"
        tabindex="0">
        <i [class]="listIcon" class="self-center justify-self-center text-xl"></i>
      </div>

      <img alt="Galia Logo" class="size-8 select-none" src="favicon.svg" />

      <div class="flex flex-col">
        <span class="text-text-primary text-sm leading-[1.1] font-bold">Galia</span>
        <span class="text-text-secondary text-xs">Atoptima</span>
      </div>
    </div>

    <ul class="grow space-y-1 font-medium">
      @for (item of topItems(); track trackSidebarItemByRoute($index, item)) {
        <app-sidebar-item
          [label]="item.labelKey | translate"
          [item]="item.item"></app-sidebar-item>
      }
    </ul>

    @if (bottomItems().length > 0) {
      <div class="bg-weak my-2 h-px font-medium"></div>
    }

    <ul class="space-y-2 font-medium">
      @for (item of bottomItems(); track trackSidebarItemByRoute($index, item)) {
        <app-sidebar-item
          [label]="item.labelKey | translate"
          [item]="item.item"></app-sidebar-item>
      }
    </ul>

    @if (user()) {
      <div class="border-weak mt-2 flex items-center gap-1 border-t px-1.5 pt-2.5 pb-1">
        <div class="flex min-w-0 flex-1 items-center gap-2">
          <div
            class="bg-accent-interactive text-accent-main flex h-6.5 w-6.5 shrink-0 items-center justify-center rounded-full font-sans text-xs font-semibold select-none">
            {{ initials() }}
          </div>
          <div class="min-w-0">
            <div class="text-text-primary truncate text-[12.5px] font-semibold">
              {{ user()!.fullName }}
            </div>
            <div class="text-text-tertiary font-mono text-[10.5px]">
              &copy; {{ year }} ·
              @if (isProduction) {
                v{{ version }}
              } @else {
                Dev
              }
            </div>
          </div>
        </div>
        <div>
          <button
            #logoutBtn
            (click)="logout()"
            class="text-text-tertiary flex shrink-0 cursor-pointer items-center justify-center rounded-sm transition-colors hover:text-red-500"
            [attr.aria-label]="'login.signout' | translate"
            type="button">
            <i [class]="signOutIcon" class="text-base"></i>
          </button>
          <app-tooltip
            [target]="logoutBtn"
            [content]="'login.signout' | translate"
            position="right" />
        </div>
      </div>
    }
  </aside>
}
